export default "__VITE_ASSET__YPjdkXVG__"